export default __webpack_public_path__ + "static/media/mhfa-badge.50c44c94.png";